import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IwgcommonModule} from '../iwgcommon/iwgcommon.module';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MaterialModule} from '../shared/material/material.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SharedPipesModule} from '../shared/pipes/sharedpipes.module';
import {MyTalentSearchComponent} from './my-talent-search.component';



@NgModule({
  declarations: [MyTalentSearchComponent],
  imports: [
    CommonModule,
    IwgcommonModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    SharedPipesModule
  ],
  exports:[MyTalentSearchComponent]
})
export class MyTalentSearchModule { }
